import { render } from "./TemporaryMessage.vue?vue&type=template&id=d0608c6a&scoped=true"
import script from "./TemporaryMessage.vue?vue&type=script&lang=js"
export * from "./TemporaryMessage.vue?vue&type=script&lang=js"

import "./TemporaryMessage.vue?vue&type=style&index=0&id=d0608c6a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0608c6a"]])

export default __exports__